import { get, post } from './client.js';

export const getIntegrations    = (orgId) => get(`/orgs/${orgId}/integrations`);
export const connectIntegration = (orgId, integrationId) => post(`/orgs/${orgId}/integrations/${integrationId}/connect`);
export const disconnectIntegration = (orgId, integrationId) => post(`/orgs/${orgId}/integrations/${integrationId}/disconnect`);
